import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useActiveProject } from '../context/ActiveProjectContext';
import Drawer from '../components/Drawer';
import Footer from '../components/Footer';

const ProfilePage = () => {
  const { user } = useAuth();
  const { selectedProject, openProjectPicker } = useActiveProject();

  const initials = user?.name
    ? user.name
        .split(' ')
        .map((n) => n[0])
        .join('')
        .toUpperCase()
        .slice(0, 2)
    : '?';

  const pageContent = (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 pb-28">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-900">Profile</h1>
        <p className="text-slate-500 text-sm mt-1">Your account information</p>
      </div>

      <div className="max-w-xl mb-6">
        <div
          className="rounded-2xl border px-5 py-4"
          style={{ borderColor: '#f9b8ca', background: '#fff6f8' }}
        >
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-xs uppercase tracking-wide font-semibold text-slate-500">
                Active Project
              </p>
              <p className="text-sm font-bold text-slate-800 mt-1">
                {selectedProject?.name || 'No project selected'}
              </p>
            </div>

            <button
              type="button"
              onClick={openProjectPicker}
              className="px-3 py-2 rounded-xl text-xs font-semibold text-white"
              style={{ background: '#c44569' }}
            >
              Change Project
            </button>
          </div>
        </div>
      </div>

      <div className="max-w-xl mb-10">
        <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden">
          <div
            className="h-28"
            style={{ background: 'linear-gradient(135deg,#c44569,#cf6a87)' }}
          />

          <div className="px-6 pb-6">
            <div className="-mt-12 mb-4">
              <div
                className="w-20 h-20 rounded-2xl bg-white shadow-lg border-4 border-white flex items-center justify-center text-2xl font-bold"
                style={{ color: '#c44569' }}
              >
                {initials}
              </div>
            </div>

            <h2 className="text-xl font-bold text-slate-900">{user?.name}</h2>
            <p className="text-slate-500 text-sm">{user?.email}</p>
          </div>

          <div className="border-t border-slate-100">
            {[
              { label: 'Full Name', value: user?.name },
              { label: 'Email Address', value: user?.email },
              { label: 'Phone Number', value: user?.phone || '—' },
              { label: 'User ID', value: user?.id ? `#${user.id}` : '—' },
              {
                label: 'Member Since',
                value: user?.created_at
                  ? new Date(user.created_at).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })
                  : '—',
              },
            ].map((item, i) => (
              <div
                key={i}
                className="flex items-center justify-between px-6 py-4 border-b border-slate-50 last:border-0 hover:bg-slate-50 transition"
              >
                <span className="text-sm text-slate-500">{item.label}</span>
                <span className="text-sm font-semibold text-slate-800">{item.value}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="h-4" />
      <Footer />
    </div>
  );

  return <Drawer pageHeader={pageContent} />;
};

export default ProfilePage;